
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '../../stores';
import TheAdmin from '@/stores/TheLogedInAdmin';

@Component({
  components: {},
})

export default class LogoutItem extends Vue {
  /**
   * Fired when this module is created
   */
  created() {
    this.logout();
  }

  logout() {
    return stores.admin.logout()
      .then(() => {
        localStorage.removeItem('menus');
        console.log('user logged out :(');
        stores.admin.reset();
        this.$router.push('/login');
      })
      .catch((reason) => {
        console.error('Could not logout', reason);
      });
  }
}
